module.exports = __webpack_public_path__ + "static/media/circle-alert.83c5c08a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/circle-alert.svg
// module id = 636
// module chunks = 0